module.exports = __webpack_public_path__ + "img/regcamStore1.65cef979.png";